export var PlatformPathname;
(function (PlatformPathname) {
    PlatformPathname["BOOKING_APPOINTMENT_PATHNAME"] = "/book-appointment";
    PlatformPathname["TIME_SELECTION_PROCESS_PATHNAME"] = "/book-appointment/process";
    PlatformPathname["STAMP_DUTY_PATHNAME"] = "/stamp-duty-calculator";
    PlatformPathname["PROPERTY_REPORT_PATHNAME"] = "/property-report";
    PlatformPathname["REFINANCE_FUNNEL_PATHNAME"] = "/home-loans/basics/refinance/refinance-loan-amount";
    PlatformPathname["NEW_PURCHASE_FUNNEL_PATHNAME"] = "/home-loans/basics/new-home/purchase-price";
    PlatformPathname["BORROWING_POWER_FUNNEL_PATHNAME"] = "/home-loans/basics/borrowing-power/applicants";
})(PlatformPathname || (PlatformPathname = {}));
//# sourceMappingURL=PlatformPathname.js.map